'use strict';

require('../modules/forms/forms');

angular.module('far.forms.committeeForm', ['dekky.forms'])
    .service('committeeForm', function(form) {
        var pageForm = form('page');

        pageForm
            .addField('content', 'textarea', {
                validators: {
                    required: false
                },
                options: {
                    redactor: true,
                    placeholder: 'Описание комитета (комиссии)'
                },
                label: 'Содержание'
            });

        return pageForm;
    });
